const DefaultMessageDuration = 6;
const DefaultMessageType = "error";

export default (store) => {
  store.registerModuleOnce("internalNotifications", {
    namespaced: true,
    state: {
      messages: [],
    },
    getters: {
      messages: (state) => {
        return state.messages;
      },
    },
    mutations: {
      // replace rather than push: watchers on `messages` compare by reference
      // in Vue 3, so an in-place mutation would never trigger them
      setMessage(state, message) {
        state.messages = [...state.messages, message];
      },
      clearMessages(state) {
        state.messages = [];
      },
    },
    actions: {
      setMessage(
        { commit },
        {
          message,
          type = DefaultMessageType,
          duration = DefaultMessageDuration,
        },
      ) {
        const params = {
          message,
          type,
          duration,
        };

        commit("setMessage", params);
      },
      clearMessages({ commit }) {
        commit("clearMessages");
      },
    },
  });
};
